import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const money = (n) => `${Number(n || 0).toLocaleString("fr-CA", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} $`;

// Accueil : archivés relancés (« on a hâte de te revoir ») → combien sont revenus payer et revenu récupéré.
export function ComebackStatsCard() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/ops/comeback-stats").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d || !d.contacted) return null;
  return (
    <div className="mx-6 md:mx-8 lg:mx-10 mt-4 rounded-xl border border-emerald-500/40 bg-emerald-500/[0.05] p-4" data-testid="comeback-stats-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-emerald-300 font-semibold">Retours d'archivés · relance « on a hâte de te revoir »</p>
          <h3 className="text-zinc-100 font-bold mt-0.5" data-testid="comeback-stats-title">{d.returned} sur {d.contacted} relancés sont revenus payer ({d.rate_pct} %)</h3>
          <p className="text-xs text-zinc-400 mt-0.5" data-testid="comeback-stats-hint">Revenu récupéré (90 j) : <b className="text-emerald-300">{money(d.recovered_90d)}</b> · récurrent ≈ {money(d.monthly_recurring)}/mois · {d.still_archived} toujours archivés</p>
        </div>
        {d.returned > 0 && <button onClick={() => setOpen((v) => !v)} className="px-3 py-1.5 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-xs text-zinc-200" data-testid="comeback-stats-toggle">{open ? "Masquer" : "Voir qui"}</button>}
      </div>
      {open && (
        <ul className="mt-3 text-xs divide-y divide-zinc-800/70" data-testid="comeback-stats-list">
          {d.returned_rows.map((r, i) => <li key={i} className="py-1 flex justify-between gap-2"><span className="text-zinc-200">{r.full_name} <span className="text-zinc-500">· {r.discipline} · revenu le {r.reactivated_at}</span></span><span className="text-emerald-300">{money(r.paid)}</span></li>)}
        </ul>
      )}
    </div>
  );
}
